import React, { useEffect, useRef, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import axiosInstance from "../../services/api";
import Loader from '../Commons/Loader';
import { useMenu } from '../../context/MenuContext';
function UsageReports() {
    const fromDatepickerRef = useRef(null);
    const toDatepickerRef = useRef(null);
    const [scheduleType, setScheduleType] = useState("daily"); // State for selection
    const [hotelReportData, setHotelReportData] = useState([]); // Set initial state as an empty array
    const [selectedGroup, setSelectedGroup] = useState(""); // Selected hotel group
    const [selectedSubGroup, setSelectedSubGroup] = useState(""); // Selected subGroup
    const [availableHotelsArr, setAvailableHotelsArr] = useState(""); // Selected subGroup
    const [selectedHotels, setSelectedHotels] = useState({});
    const [selectedHotelsValue, setSelectedHotelsValue] = useState([]);
    const [uncheckedHotelsValue, setUncheckedHotelsValue] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [onChangeKey, setOnChangeKey] = useState("false");
    const [checkAll, setCheckAll] = useState(true); // State for "Check All"
    const [currentTimeB, setcurrentTime] = useState("");
    const [loading, setLoading] = useState(true);
    const userDetails = useMenu();
    //const [userType, setUserType] = useState("user");

    const fetchData = async () => {
        try {
            console.log("Fetching data...");
            const response = await axiosInstance.get('hotel/all-hotels-by-group.json'); // Make a GET request
            console.log("Response received:", response);
            setHotelReportData(response.data.data.groups || []); // Set the entire array of users
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
            fetchData();
    }, []);
    useEffect(() => {
        
    }, [hotelReportData]);
    useEffect(() => {
        $(".ui-datepicker").removeClass("month-year-picker");

    // ✅ Skip this logic if scheduleType is financialYear
        if (scheduleType === "financial_year") return;
        $(toDatepickerRef.current).datepicker("destroy"); 

        
        if (scheduleType === "monthly") {
            $(toDatepickerRef.current).prop('disabled', true);  // Disable the input field
        }else if (scheduleType === "daily" && userDetails.userDetails.userType === "USER" || scheduleType === "weekly" && userDetails.userDetails.userType === "USER") {
           $(toDatepickerRef.current).prop('disabled', true);  
        }
        else {
            $(toDatepickerRef.current).prop('disabled', false);  // Enable the input field
        }
        // Function to enable the first day of the week/month
        const enableFirstDayOfWeek = (date) => {
            if (scheduleType === "weekly") {
                if (date.getDay() === 0) { // Only Sundays
                    if (userDetails.userDetails.userType === "USER") {
                        const threeWeeksLater = new Date(date);
                        threeWeeksLater.setDate(threeWeeksLater.getDate() + 20);

                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Remove time

                        // Only enable Sundays where Sunday + 20 days <= today
                        return [threeWeeksLater <= today];
                    }
                    return [true]; // Admin: all Sundays enabled
                }
                return [false]; // All other days disabled
            } else if (scheduleType === "monthly") {
                return [date.getDate() === 1]; // Enable only 1st day of month
            } else {
                return [true]; // Enable all days for Daily
            }
        };

        // Function to enable the last day of the week/month
        const enableLastDayOfWeek = (date) => {
            if (scheduleType === "weekly") {
                return [date.getDay() === 6]; // Enable only Saturdays
            } else if (scheduleType === "monthly") {
                let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate(); // Get last date of the month
                return [date.getDate() === lastDay]; // Enable only last day of the month
            } else {
                return [true]; // Enable all days for Daily
            }
        };

                // Get the current date
        const today = new Date();
        const maxFromDate = new Date(today);
        maxFromDate.setDate(today.getDate() - 3);
        // for download file start
        const formattedDate = today.toISOString().split('T')[0];
        const hours = today.getHours().toString().padStart(2, '0'); // Pad with leading zero if necessary
        const minutes = today.getMinutes().toString().padStart(2, '0');
        const seconds = today.getSeconds().toString().padStart(2, '0');
        const currentTime = `${hours}:${minutes}:${seconds}`;
        setcurrentTime(`${formattedDate}-${currentTime}`)
        // for download file end

        // Calculate the minDate (current month)
        //const minDate = new Date(today.getFullYear(), today.getMonth(), 1);
        let minDate;
        let initialViewDate;
        if(scheduleType === "monthly") {
            minDate = new Date(today);
            minDate.setMonth(today.getMonth() - 3); // Set minDate to 3 months ago
            minDate.setDate(1); // Set it to the first day of that month
            initialViewDate = minDate;
        }else{
            minDate = new Date(today.getFullYear(), today.getMonth(), 1);
        }
        
        // Calculate the maxDate (next 2 months from now)
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, 31);

        // Destroy old datepickers and reinitialize with new settings
        $(fromDatepickerRef.current).datepicker("destroy").datepicker({
            beforeShowDay: enableFirstDayOfWeek,
            dateFormat: "yy-mm-dd",
            //maxDate: scheduleType === "monthly" ? initialViewDate : today,
            maxDate :
            scheduleType === "monthly"
                ? initialViewDate
                : scheduleType === "daily" && userDetails.userDetails.userType === "USER"
                ? maxFromDate
                : today,
            defaultDate: initialViewDate, // Set the initial view date to 3 months ago
            setDate: initialViewDate,
            onSelect: (dateText) => {
                
                //console.log(dateText,"dateText")
                if(scheduleType === "monthly"){
                    console.log("jop");
                        const selectedDate = new Date(dateText);
                        const selectedYear = selectedDate.getFullYear();
                        const selectedMonth = selectedDate.getMonth(); // 0-based index (Jan = 0)
                        // Set "From Date"
                        setFromDate(dateText);
                         // Store To Date in state
                        const currentYear = new Date().getFullYear(); 
                        let toDate; // Last day of the month (3 months later)
                        let toDateFormatted; 
                        if(selectedYear===currentYear){
                            // toDate = new Date(selectedYear, selectedMonth + 1, 1);
                            toDate = new Date(selectedYear, selectedMonth + 3, 1);
                            toDateFormatted = toDate.toISOString().split('T')[0];
                        }else{
                            toDate = new Date(selectedYear, selectedMonth + 3, 1);
                            toDateFormatted = toDate.toISOString().split('T')[0];
                        }
                        setToDate(toDateFormatted);
                }else if (scheduleType === "weekly") {
                    // Set "From Date"
                    if(userDetails.userDetails.userType === "ADMIN") {
                        // const selectedDate = new Date(dateText);
                        // const selectedYear = selectedDate.getFullYear();
                        // const selectedMonth = selectedDate.getMonth(); // 0-based index (Jan = 0)
                    
                        // console.log(selectedDate, "Selected From Date");
                        
                        // // Set "To Date" range to 2 months after the selected "From Date"
                        // const minDate = new Date(selectedYear, selectedMonth, selectedDate.getDate()); // "From Date"
                        // // const maxDate = new Date(selectedYear, selectedMonth + 3, 0); // Last day of the second month
                        // const currentDate = new Date(); // Today's date
                        // const currentYear = new Date().getFullYear(); 
                        // const currentMonth = new Date().getMonth(); 
                        // let maxDate;
                        // if (selectedMonth >= 10) {  // If the selected month is November (10) or December (11)
                        //     // Max date will be the current month
                        //     maxDate = new Date(currentYear, currentMonth + 1, 0); // Last day of the current month
                        // } else {
                        //     // For other months, max date is 3 months ahead of the selected month
                        //     maxDate = new Date(selectedYear, selectedMonth + 3, 0); // Last day of the month 3 months ahead
                        // }
                        // if (maxDate > currentDate) {
                        //     maxDate = currentDate; // Set maxDate to today's date if it's in the future
                        // }

                        // setToDate("");
                        // setFromDate(dateText); // Store selected date in state
                    
                        // // Initialize DatePicker for "To Date"
                        // $(toDatepickerRef.current).datepicker("destroy").datepicker({
                        //     dateFormat: "yy-mm-dd",
                        //     minDate: minDate, // From Date
                        //     maxDate: maxDate, // 2 months from selected date
                        //     defaultDate: minDate,
                        //     beforeShow: function (input, inst) {
                        //         $(this).datepicker("option", "defaultDate", minDate);
                        //     },
                        //     beforeShowDay: function(date) {
                        //         // Enable only Saturdays in the next 2 months from selected date
                        //         const isInRange = (date >= minDate && date <= maxDate);
                        //         const isSaturday = (date.getDay() === 6); // Saturday = 6
                        //         return (isInRange && isSaturday) ? [true, ""] : [false, ""];
                        //     },
                        //     onSelect: (dateText) => {
                        //         setToDate(dateText);
                        //     }
                        // });

                        const selectedDate = new Date(dateText);
                        const selectedYear = selectedDate.getFullYear();
                        const selectedMonth = selectedDate.getMonth(); // 0-based (Jan = 0)

                        console.log(selectedDate, "Selected From Date");

                        // From Date
                        const minDate = new Date(selectedYear, selectedMonth, selectedDate.getDate());

                        // Calculate max date: end of the 3rd month from selected
                        let maxDate = new Date(selectedYear, selectedMonth + 3, 0); // ✅ let allows reassignment

                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0);
                        if (maxDate > currentDate) {
                            maxDate = currentDate; // ✅ now this reassignment is allowed
                        }

                        setToDate("");
                        setFromDate(dateText);

                        // Initialize To Datepicker
                        $(toDatepickerRef.current).datepicker("destroy").datepicker({
                            dateFormat: "yy-mm-dd",
                            minDate: minDate,
                            maxDate: maxDate,
                            defaultDate: minDate,
                            beforeShow: function (input, inst) {
                                $(this).datepicker("option", "defaultDate", minDate);
                            },
                            beforeShowDay: function (date) {
                                const isInRange = (date >= minDate && date <= maxDate);
                                const isSaturday = (date.getDay() === 6); // Saturday = 6
                                return (isInRange && isSaturday) ? [true, ""] : [false, ""];
                            },
                            onSelect: (dateText) => {
                                setToDate(dateText);
                            }
                        });

                    }else{
                        const selectedDate = new Date(dateText);
                        const selectedYear = selectedDate.getFullYear();
                        const selectedMonth = selectedDate.getMonth(); // 0-based index (Jan = 0)
                        const selectedDay = selectedDate.getDate();

                        console.log(selectedDate, "Selected From Date");

                        const minDate = new Date(selectedYear, selectedMonth, selectedDay); // "From Date"
                        const currentDate = new Date(); // Today's date

                        let maxDate;
                        const currentYear = currentDate.getFullYear(); 
                        const currentMonth = currentDate.getMonth(); 

                        if (selectedMonth >= 10) {
                            maxDate = new Date(currentYear, currentMonth + 1, 0); // End of current month
                        } else {
                            maxDate = new Date(selectedYear, selectedMonth + 3, 0); // 3 months ahead
                        }

                        if (maxDate > currentDate) {
                            maxDate = currentDate; // Cap at today
                        }

                        // ===> Calculate default To Date (3 weeks later)
                        let defaultToDate = new Date(selectedDate);
                        defaultToDate.setDate(defaultToDate.getDate() + 20); // 3 weeks ahead

                        if (defaultToDate > maxDate) {
                            defaultToDate = maxDate; // Cap defaultToDate if it exceeds maxDate
                        }

                        setFromDate(dateText); // Store selected from-date
                        setToDate(formatDate(defaultToDate)); // Pre-set To Date state

                        // Initialize DatePicker for "To Date"
                        $(toDatepickerRef.current).datepicker("destroy").datepicker({
                            dateFormat: "yy-mm-dd",
                            minDate: minDate,
                            maxDate: maxDate,
                            defaultDate: defaultToDate,
                            beforeShow: function (input, inst) {
                                $(this).datepicker("option", "defaultDate", defaultToDate);
                            },
                            beforeShowDay: function(date) {
                                const isInRange = (date >= minDate && date <= maxDate);
                                const isSaturday = (date.getDay() === 6);
                                return (isInRange && isSaturday) ? [true, ""] : [false, ""];
                            },
                            onSelect: (dateText) => {
                                setToDate(dateText);
                            }
                        });

                        // Helper function to format date to "yyyy-mm-dd"
                        function formatDate(date) {
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
                            const day = String(date.getDate()).padStart(2, '0');
                            return `${year}-${month}-${day}`;
                        }

                    }
                }
                
                
                else {

                    if(userDetails.userDetails.userType === "ADMIN") {
                        // const selectedDate = new Date(dateText);
                        // //const selectedMonth = selectedDate.getMonth() + 1; // Months are 0-indexed, so add 1
                        // const selectedYear = selectedDate.getFullYear();
                        // const selectedMonth = selectedDate.getMonth(); // 0-based index (Jan = 0)
                        // console.log(selectedDate,"selectedDate")
                        // // Set "To Date" range to the exact month 2 months later
                        // const minDate = new Date(selectedYear, selectedMonth + 2, 1); // 1st of the month (2 months later)
                        // console.log(selectedYear,"selectedYear")
                        // const currentDate = new Date(); // Today's date
                        // const currentYear = new Date().getFullYear(); 
                        // const currentMonth = new Date().getMonth(); 
                        // let maxDate;

                        // if (selectedMonth >= 10) {  // If the selected month is November (10) or December (11)
                        //     console.log("kkkk")
                        //     // Max date will be the current month
                        //     maxDate = new Date(currentYear, currentMonth + 1, 0); // Last day of the current month
                        // } else {
                        //     // For other months, max date is 3 months ahead of the selected month
                        //     maxDate = new Date(selectedYear, selectedMonth + 3, 0); // Last day of the month 3 months ahead
                        // }
                        // if (maxDate > currentDate) {
                        //     maxDate = currentDate; // Set maxDate to today's date if it's in the future
                        // }
                        // setToDate("");
                        // setFromDate(dateText); // Store selected date in state
                        // $(toDatepickerRef.current).datepicker("destroy").datepicker({
                        //     dateFormat: "yy-mm-dd",
                        //     minDate: dateText, // First day of the month 2 months later
                        //     maxDate: maxDate, // Last day of the month 2 months later
                        //     defaultDate: dateText, 
                        //     beforeShow: function (input, inst) {
                        //         // Adjust the calendar's default month to match "From Date"
                        //         $(this).datepicker("option", "defaultDate", dateText);
                        //     },
                        //     onSelect: (dateText) => {
                        //         setToDate(dateText);
                        //     }
                        // });
                        const selectedDate = new Date(dateText);
                        const selectedYear = selectedDate.getFullYear();
                        const selectedMonth = selectedDate.getMonth(); // 0-based index

                        console.log(selectedDate, "Selected From Date");

                        // Minimum date = the selected "From" date
                        const minDate = new Date(selectedYear, selectedMonth, selectedDate.getDate());

                        // Max date = end of month 3 months from selected
                        let maxDate = new Date(selectedYear, selectedMonth + 3, 0);

                        // Restrict maxDate to today if calculated maxDate exceeds today
                        const currentDate = new Date();
                        currentDate.setHours(0, 0, 0, 0); // Normalize for comparison

                        if (maxDate > currentDate) {
                            maxDate = currentDate;
                        }

                        setToDate("");
                        setFromDate(dateText);

                        // Initialize "To Date" picker
                        $(toDatepickerRef.current).datepicker("destroy").datepicker({
                            dateFormat: "yy-mm-dd",
                            minDate: minDate,
                            maxDate: maxDate,
                            defaultDate: minDate,
                            beforeShow: function (input, inst) {
                                $(this).datepicker("option", "defaultDate", minDate);
                            },
                            onSelect: (dateText) => {
                                setToDate(dateText);
                            }
                        });

                    }else{
                        const selectedDate = new Date(dateText); // From Date selected
                        const selectedYear = selectedDate.getFullYear();
                        const selectedMonth = selectedDate.getMonth();

                        const currentDate = new Date(); // Today
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = currentDate.getMonth();

                        let maxDate;
                        
                        // Determine the maxDate as before
                        if (selectedMonth >= 10) {
                            maxDate = new Date(currentYear, currentMonth + 1, 0); // End of current month
                        } else {
                            maxDate = new Date(selectedYear, selectedMonth + 3, 0); // End of 3rd month ahead
                        }

                        // Ensure maxDate doesn't go beyond today
                        if (maxDate > currentDate) {
                            maxDate = currentDate;
                        }

                        // Calculate new To Date = selectedDate + 2 days
                        const autoToDate = new Date(selectedDate);
                        autoToDate.setDate(autoToDate.getDate() + 2);

                        // Ensure autoToDate does not exceed maxDate
                        if (autoToDate > maxDate) {
                            autoToDate.setTime(maxDate.getTime());
                        }

                        // Format date as "yyyy-mm-dd"
                        const formatDate = (date) => {
                            return date.toISOString().split("T")[0];
                        }

                        setFromDate(dateText);
                        setToDate(formatDate(autoToDate)); // Set To Date = From Date + 2 days

                        $(toDatepickerRef.current).datepicker("destroy").datepicker({
                            dateFormat: "yy-mm-dd",
                            minDate: selectedDate,          // Can't go before From Date
                            maxDate: maxDate,               // Can't go beyond allowed max
                            defaultDate: autoToDate,        // Auto show 2 days later
                            beforeShow: function (input, inst) {
                                $(this).datepicker("option", "defaultDate", autoToDate);
                            },
                            onSelect: (dateText) => {
                                setToDate(dateText); // Update To Date on user selection
                            }
                        });


                    }
   
                    

                }
            }
        });
 
        $(toDatepickerRef.current).datepicker("destroy").datepicker({
            beforeShowDay: enableLastDayOfWeek,
            dateFormat: "yy-mm-dd",
            onSelect: (dateText) => {
                setToDate(dateText); // Store selected date in state
            },
            minDate: minDate,
            maxDate: 0,
        });

        
    }, [scheduleType]); // Re-run effect when scheduleType changes
    
    useEffect(() => {

        if (scheduleType === "financial_year") {
            $(toDatepickerRef.current).prop('disabled', false);
            //  const today = new Date();
            const todayYear = new Date();
            const maxDateYear = new Date(todayYear.getFullYear(), todayYear.getMonth(), 0); // End of current month

            // // Default From = June of last year
            // const defaultFrom = new Date(today.getFullYear() - 1, 5, 1); // June 1 (month is 0-based)
            // const formattedFrom = `${defaultFrom.getFullYear()}-${String(defaultFrom.getMonth() + 1).padStart(2, '0')}-01`;

            // // Default To = Last day of previous month
            // const defaultTo = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of prev month
            // const formattedTo = `${defaultTo.getFullYear()}-${String(defaultTo.getMonth() + 1).padStart(2, '0')}-${String(defaultTo.getDate()).padStart(2, '0')}`;
            const today = new Date();

            // To Date = last day of previous month
            const defaultTo = new Date(today.getFullYear(), today.getMonth(), 0);

            // From Date = 14 months ago from current month
            let fromMonth = today.getMonth() - 14;
            let fromYear = today.getFullYear();

            if (fromMonth < 0) {
                fromYear -= Math.ceil(Math.abs(fromMonth) / 12);
                fromMonth = (fromMonth % 12 + 12) % 12;
            }

            const defaultFrom = new Date(fromYear, fromMonth, 1);

            // Format for state
            const formattedFrom = `${defaultFrom.getFullYear()}-${String(defaultFrom.getMonth() + 1).padStart(2, '0')}-${String(defaultFrom.getDate()).padStart(2, '0')}`;
            const formattedTo = `${defaultTo.getFullYear()}-${String(defaultTo.getMonth() + 1).padStart(2, '0')}-${String(defaultTo.getDate()).padStart(2, '0')}`;



            // Set initial state in React
            setFromDate(formattedFrom);
            setToDate(formattedTo);

            // Set values in input fields
            setTimeout(() => {
                $(fromDatepickerRef.current).val(formattedFrom);
                // $(toDatepickerRef.current).val(formattedTo);
            }, 0);


            // FROM DATE PICKER
            $(fromDatepickerRef.current).datepicker("destroy").datepicker({
                changeMonth: true,
                changeYear: true,
                showButtonPanel: true,
                dateFormat: "MM yy",
                defaultDate: defaultFrom,
                maxDate: maxDateYear,
                yearRange: "-5:+0", // ✅ Current year to 5 years back
                onClose: function (dateText, inst) {
                    const donePressed = $(fromDatepickerRef.current)
                        .datepicker("widget")
                        .find(".ui-datepicker-close:focus").length > 0;

                    if (donePressed) {
                        const month = inst.selectedMonth;
                        const year = inst.selectedYear;

                        if (!isNaN(month) && !isNaN(year)) {
                            const selectedDate = new Date(year, month, 1);
                            //const formatted = `${year}-${String(month + 1).padStart(2, '0')}-01`;
                            const formatted = `${year}-${String(month + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;

                            setFromDate(formatted);

                            

                            setTimeout(() => {
                                $(fromDatepickerRef.current).val(formatted);
                            }, 0);

                            //$(this).datepicker("setDate", selectedDate);
                            // ✅ Update the Datepicker's defaultDate
                            $(this).datepicker("setDate", selectedDate);
                            $(this).datepicker("option", "defaultDate", selectedDate);

                            const maxToDate = new Date(year, month + 12, 0); // last day of next year's same month
                            const maxDate = (maxToDate < maxDateYear) ? maxToDate : maxDateYear; // Ensure global max limit

                            setToDate("");
                            setTimeout(() => {
                                $(toDatepickerRef.current).val("");
                            }, 0);

                            // TO DATE PICKER - Initialize after From Date is selected
                            $(toDatepickerRef.current).datepicker("destroy").datepicker({
                                changeMonth: true,
                                changeYear: true,
                                showButtonPanel: true,
                                dateFormat: "MM yy",
                                minDate: selectedDate,
                                maxDate: maxDate,
                                onClose: function (toDateText, toInst) {
                                    const donePressed = $(toDatepickerRef.current)
                                        .datepicker("widget")
                                        .find(".ui-datepicker-close:focus").length > 0;

                                    if (donePressed) {
                                        const toMonth = toInst.selectedMonth;
                                        const toYear = toInst.selectedYear;

                                        if (!isNaN(toMonth) && !isNaN(toYear)) {
                                            const lastDayOfMonth = new Date(toYear, toMonth + 1, 0);
                                            const formattedTo = `${toYear}-${String(toMonth + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;

                                            // const formattedTo = `${String(lastDayOfMonth.getDate()).padStart(2, '0')}-${String(toMonth + 1).padStart(2, '0')}-${toYear}`;

                                            setToDate(formattedTo);
                                            // setTimeout(() => {
                                            //     $(toDatepickerRef.current).val(formattedTo);
                                            // }, 0);

                                            // $(this).datepicker("setDate", lastDayOfMonth);
                                            $(toDatepickerRef.current).datepicker("setDate", lastDayOfMonth);
                                            $(toDatepickerRef.current).datepicker("option", "defaultDate", lastDayOfMonth);


                                        }
                                    }
                                },
                                beforeShow: function (input) {
                                    setTimeout(() => {
                                        $(input).datepicker("widget").addClass("month-year-picker");
                                    }, 0);
                                }
                            });
                        }
                    }
                },
                beforeShow: function (input) {
                    setTimeout(() => {
                        $(input).datepicker("widget").addClass("month-year-picker");
                    }, 0);
                }
            });

            // TO DATE PICKER (initial state if needed)
            $(toDatepickerRef.current).datepicker("destroy").datepicker({
                changeMonth: true,
                changeYear: true,
                showButtonPanel: true,
                dateFormat: "MM yy",
                defaultDate: defaultTo,
                minDate: defaultFrom,
                yearRange: "-5:+0", // ✅ Current year to 5 years back
                maxDate: maxDateYear,
                onClose: function (toDateText, toInst) {
                    const donePressed = $(toDatepickerRef.current)
                        .datepicker("widget")
                        .find(".ui-datepicker-close:focus").length > 0;

                    if (donePressed) {
                        const toMonth = toInst.selectedMonth;
                        const toYear = toInst.selectedYear;

                        if (!isNaN(toMonth) && !isNaN(toYear)) {
                            const lastDayOfMonth = new Date(toYear, toMonth + 1, 0);
                            const formattedTo = `${toYear}-${String(toMonth + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;

                            // const formattedTo = `${String(lastDayOfMonth.getDate()).padStart(2, '0')}-${String(toMonth + 1).padStart(2, '0')}-${toYear}`;

                            setToDate(formattedTo);
                            // setTimeout(() => {
                            //     $(toDatepickerRef.current).val(formattedTo);
                            // }, 0);

                            // $(this).datepicker("setDate", lastDayOfMonth);
                            $(toDatepickerRef.current).datepicker("setDate", lastDayOfMonth);
                            $(toDatepickerRef.current).datepicker("option", "defaultDate", lastDayOfMonth);


                        }
                    }
                },
                beforeShow: function (input) {
                    setTimeout(() => {
                        $(input).datepicker("widget").addClass("month-year-picker");
                    }, 0);
                }
            });
        }

    }, [scheduleType]);

    

    useEffect(() => {
        console.log(fromDate,toDate, "Date");
    }, [fromDate, toDate]);

    // Handle schedule type selection
    const handleChange = (e) => {
        setScheduleType(e.target.value);
        setFromDate('');
        setToDate('')
        // console.log(fromDate, "fromDate")
        //  // Reset the "From Date" picker
        $(fromDatepickerRef.current).datepicker("setDate", null);

        // Reset the "To Date" picker
        $(toDatepickerRef.current).datepicker("setDate", null);
    };

    const selectedHotelGroup = useMemo(() => {
        return hotelReportData.find(group => group.name === selectedGroup);
    }, [hotelReportData, selectedGroup]);
    const availableHotels = useMemo(() => {
        return selectedHotelGroup ? selectedHotelGroup.hotels : [];
    }, [selectedHotelGroup]);
    
    const availableSubGroups = useMemo(() => {
        return selectedHotelGroup ? selectedHotelGroup.subGroups : [];
    }, [selectedHotelGroup]);
  
    const selectedSubGroupHotels = useMemo(() => {
        if (selectedHotelGroup && selectedSubGroup) {
            return selectedHotelGroup.subGroups.find(sub => sub.name === selectedSubGroup)?.hotels || [];
        }
        return [];
    }, [selectedHotelGroup, selectedSubGroup]);

    useEffect(() => {
        if (selectedSubGroup) {
            setAvailableHotelsArr(selectedSubGroupHotels); // Set subGroup hotels if subGroup is selected
        } else {
            setAvailableHotelsArr(availableHotels); // Otherwise, set group hotels
        }
    }, [selectedGroup, selectedSubGroup, availableHotels, selectedSubGroupHotels]);
    // new one for auto select
    useEffect(() => {
        // Auto-select the first subGroup if available
        if (selectedHotelGroup && selectedHotelGroup.subGroups?.length > 0) {
            const firstSubGroup = selectedHotelGroup.subGroups[0];
            setSelectedSubGroup(firstSubGroup.name);
        } else {
            setSelectedSubGroup(""); // Clear if no subGroups
        }
    }, [selectedGroup, selectedHotelGroup]);
    // new one for auto select
    useEffect(() => {
        if (availableHotelsArr.length > 0) {
            const defaultSelected = availableHotelsArr.reduce((acc, hotel) => {
                acc[hotel.id] = true; // Mark all hotels as selected (checked)
                return acc;
            }, {});
            setSelectedHotels(defaultSelected); // Set all hotels as selected
            
            const defaultSelectedValue = availableHotelsArr.map((item, index) => {
                return item.hubRegistrationId;
            }, {});
            //console.log(defaultSelectedValue,"defaultSelectedValue")
            setSelectedHotelsValue(defaultSelectedValue)
            setSelectedHotels(defaultSelected); // Set all hotels as selected
        }
    }, [availableHotelsArr]);


     // State for "Check All"
    const handleCheckAll = () => {
        setCheckAll(!checkAll); // Toggle the "Check All" state
        const updatedState = availableHotelsArr.reduce((acc, hotel) => {
            acc[hotel.id] = !checkAll; // Set all hotels to the opposite of the current "Check All" state
            return acc;
        }, {});
        setSelectedHotels(updatedState);
    
        const updatedValues = !checkAll
            ? availableHotelsArr.map((hotel) => hotel.hubRegistrationId) // Add all hotel hubRegistrationIds
            : []; // Clear all selected values
        setSelectedHotelsValue(updatedValues);
    };
 // State for "Check All"

    const handleCheckboxChange = (hotelId, hubRegistrationId) => {
        setSelectedHotels(prevState => {
          console.log("prevState", prevState)
            const updatedState = { ...prevState, [hotelId]: !prevState[hotelId] };
    
            // Update selectedHotelsValue based on checkbox state
            setSelectedHotelsValue(prevSelected => {
                if (updatedState[hotelId]) {
                    // If checked, add the value
                    return [...prevSelected, hubRegistrationId];
                } else {
                    // If unchecked, remove the value
                    return prevSelected.filter(id => id !== hubRegistrationId);
                }
            });
             // Dynamically update "Check All" state based on individual selections
             const allSelected = Object.values(updatedState).every(selected => selected);
             setCheckAll(allSelected);
    
            return updatedState;
        });
    };
    
    // const handleSubmit = async (e) => {
    //     try {
    //         setLoading(true);
    //         const response = await axiosInstance.get(
    //             `report/export-report?hotelName=${selectedHotelsValue}&startDate=${fromDate}&endDate=${toDate}&period=${scheduleType}`,
    //             {
    //                 responseType: "blob", // Ensure binary data is handled correctly
    //                 timeout: 120000 // Timeout set to 60 seconds (60000 ms)
    //             }
    //         );
    
    //         if (!response.data || response.data.size === 0) {
    //             console.error("Received empty file. Check API response.");
    //             return;
    //         }
    
    //         // Determine file type (Assume PDF if not provided)
    //         const contentType = response.headers["content-type"] || "application/pdf";
    
    //         // Create a Blob from the response data
    //         const blob = new Blob([response.data], { type: contentType });
    //         // Generate a temporary URL for the file
    //         const downloadUrl = window.URL.createObjectURL(blob);
    //         // Create a hidden <a> element to trigger the download
    //         const link = document.createElement("a");
    //         link.href = downloadUrl;
    //         const capitalizedGroup = selectedGroup.charAt(0).toUpperCase() + selectedGroup.slice(1).toLowerCase();
    //         const today = new Date();
    //     // for download file start
    //         const formattedDate = today.toISOString().split('T')[0];
    //         const hours = today.getHours().toString().padStart(2, '0'); // Pad with leading zero if necessary
    //         const minutes = today.getMinutes().toString().padStart(2, '0');
    //         const seconds = today.getSeconds().toString().padStart(2, '0');
    //         const currentTime = `${hours}:${minutes}:${seconds}`;
    //         setcurrentTime(`${formattedDate}-${currentTime}`)
    //         const DownloadFileName = `${capitalizedGroup}-Report-${currentTimeB}.xlsx`;
    //         link.setAttribute("download", DownloadFileName); // Set the default file name
    //         document.body.appendChild(link);
    //         link.click();
    
    //         // Cleanup
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(downloadUrl);
            

    //     } catch (error) {
    //         console.error('Error validating OTP:', error);
    //     }finally {
    //         setLoading(false);
    //       }

    // };

    const handleSubmit = async (format) => {
        try {
          setLoading(true);
          
          const response = await axiosInstance.get(
            `report/export-report?hotelName=${selectedHotelsValue}&startDate=${fromDate}&endDate=${toDate}&period=${scheduleType}&format=${format}`,
            {
              responseType: "blob", // Handle binary data correctly
              timeout: 120000, // Timeout set to 120 seconds (120000 ms)
            }
          );
      
          if (!response.data || response.data.size === 0) {
            console.error("Received empty file. Check API response.");
            return;
          }
      
          // Determine file type
          const contentType = response.headers["content-type"] || (format === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: contentType });
      
          // Generate a temporary URL for the file
          const downloadUrl = window.URL.createObjectURL(blob);
      
          // Create a hidden <a> element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          
          const capitalizedGroup = selectedGroup.charAt(0).toUpperCase() + selectedGroup.slice(1).toLowerCase();
          const today = new Date();
          
          // Format date and time for file name
          const formattedDate = today.toISOString().split('T')[0];
          const hours = today.getHours().toString().padStart(2, '0');
          const minutes = today.getMinutes().toString().padStart(2, '0');
          const seconds = today.getSeconds().toString().padStart(2, '0');
          const currentTime = `${formattedDate}-${hours}-${minutes}-${seconds}`;
      
          const DownloadFileName = `${capitalizedGroup}-Report-${currentTime}.${format}`;
          link.setAttribute("download", DownloadFileName);
      
          document.body.appendChild(link);
          link.click();
      
          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
          console.error("Error downloading file:", error);
        } finally {
          setLoading(false);
        }
    };
      

    const isDisabled = onChangeKey==="false" || !fromDate || !toDate || selectedHotelsValue.length===0 ;

    console.log(userDetails.userDetails.userType,"kop")
    return (
        <>
            {loading && <Loader />} 

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Usage Report</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Usage Report</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <div className='usage-report-section'>
                        <div className='usage-report-top'>
                            <div className='row'>
                                <div className="col-lg-2 mb-mob">
                                    <select className='select-fld' onChange={handleChange}>
                                        <option value="daily">Daily </option>
                                        <option value="weekly">Weekly </option>
                                        <option value="monthly">Monthly </option>
                                        <option value="financial_year">Financial Year </option>
                                    </select>
                                </div>
                                <div className="col-lg-3">
                                    <div className='form-group d-flex items-center'>
                                        <input type="text" placeholder="Start Date" className='input-fld'  ref={fromDatepickerRef}/>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className='form-group d-flex items-center'>
                                        <input type="text" placeholder="End Date" className='input-fld' ref={toDatepickerRef} value={toDate}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='usage-report-bottom'>
                            <div className='row'>
                                <div className="col-lg-6 mb-mob">
                                <select className='select-fld' onChange={(e) => { 
                                    setSelectedGroup(e.target.value); 
                                    setOnChangeKey("true");
                                    setSelectedHotelsValue([]);
                                    setCheckAll(true)
                                    setSelectedSubGroup(""); // Reset subGroup when group changes
                                }}>
                                    <option value="">Select Group</option>
                                    {hotelReportData.map((group) => (
                                        <option key={group.name} value={group.name}>
                                            {group.displayName}
                                        </option>
                                    ))}
                                </select>
                                </div>
                                <div className="col-lg-6">
                                {availableSubGroups.length > 0 && (
                                    <>
                                        <select value={selectedSubGroup} onChange={(e) => {
                                            setSelectedSubGroup(e.target.value);
                                            setCheckAll(true)
                                            setSelectedHotelsValue([])
                                            }} className='select-fld'>
                                            {/* <option value="">Select SubGroup</option> */}
                                            {availableSubGroups.map((subGroup) => (
                                                <option key={subGroup.name} value={subGroup.name}>
                                                    {subGroup.displayName}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                )}
                                </div>
                            </div>

                            <div className='Hotels-name-group'>
                                
                                    <div className="check-all d-flex justify-between items-center">
                                        <h2>All Hotel Group </h2>
                                        {availableHotelsArr.length > 0 &&
                                            <div className="icheck-primary d-inline">
                                                <input
                                                    type="checkbox"
                                                    id="checkAll"
                                                    checked={checkAll}
                                                    onChange={handleCheckAll}
                                                />
                                                <label htmlFor="checkAll">{checkAll===true ?<span>Deselect All</span> :<span>Select All</span>}</label>
                                            </div>
                                        }
                                    </div>
                                
                                <ul>
                                    {availableHotelsArr.length > 0 && availableHotelsArr.map((item, index) => (
                                        <li key={index}>
                                            <div className="icheck-primary d-inline">
                                                <input
                                                    type="checkbox"
                                                    id={`checkboxPrimary${item.id}`}
                                                    checked={selectedHotels[item.id] || false} // Check if this hotel is selected
                                                    onChange={() => handleCheckboxChange(item.id, item.hubRegistrationId)} // Toggle checkbox state
                                                />
                                                <label htmlFor={`checkboxPrimary${item.id}`}>{item.hotelName}</label>
                                            </div>
                                        </li>
                                    ))}
                                    {availableHotelsArr.length === 0 && (
                                        <li className="no-available">
                                            No hotel available
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="row">
                            {/* {userDetails.userDetails.userDesignation === "ADMIN" ? (
                                <>
                                <div className="col-2">
                                    <button
                                    className="btn btn-primary submit-btn"
                                    onClick={() => handleSubmit("xlsx")}
                                    disabled={isDisabled}
                                    >
                                        Download xlsx
                                    </button>
                                </div>
                                <div className="col-2">
                                    <button
                                    className="btn btn-primary submit-btn"
                                    onClick={() => handleSubmit("pdf")}
                                    disabled={isDisabled}
                                    >
                                        Download pdf
                                    </button>
                                </div>
                                </>
                            ) : (
                                <div className="col-2">
                                    <button
                                    className="btn btn-primary submit-btn"
                                    onClick={() => handleSubmit("pdf")}
                                    disabled={isDisabled}
                                    >
                                        Download pdf
                                    </button>
                                </div>
                            )} */}
                                <div className="col-2">
                                    <button
                                    className="btn btn-primary submit-btn"
                                    onClick={() => handleSubmit("xlsx")}
                                    disabled={isDisabled}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>

                    </div>
                </div>{/* /.container-fluid */}
            </section>

        </>
    );
}

export default UsageReports;
